import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/auth.service";
import * as i2 from "@angular/router";
export class AnonymousGuard {
    constructor(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    canActivate(next, state) {
        return this.auth.isAuthenticated()
            .pipe(map(authenticated => {
            if (!authenticated) {
                return true;
            }
            else {
                this.router.navigate(['']);
                return false;
            }
        }));
    }
    canActivateChild(next, state) {
        return true;
    }
    canLoad(route, segments) {
        return true;
    }
}
AnonymousGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnonymousGuard_Factory() { return new AnonymousGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router)); }, token: AnonymousGuard, providedIn: "root" });
